import createRepositoryTag from 'api/v2/repository/createRepositoryTag';
import useMutation from 'hooks/react-query/useMutation';

import type { TagItemType } from 'types/repository.types';
import useGetRepositoryTags from './useGetRepositoryTags';

const useCreateTag = (onSuccess?: (newTag: TagItemType) => void) => {
  const tagsQuery = useGetRepositoryTags();

  const createTagAPI = useMutation(createRepositoryTag, {
    onSuccess: (data) => {
      tagsQuery.refetch().then(() => {
        onSuccess?.(data);
      });
    },
  });

  return createTagAPI;
};

export default useCreateTag;
